import { Component, Prop, Vue } from "vue-property-decorator";
import { Modal, Select, Button } from "ant-design-vue";
import { CommonLocale, LessonPlanLocale } from "@/locales/localeid";
import { getModule } from "vuex-module-decorators";
import { ComponentTaughtType } from "@/models/master-plan";
import { MethodologyTypeEnum } from "@/util/enum";
import LessonPlanListState from "@/modules/lesson-plan-list";
import LessonPlanVersionSelect from "../../../lesson-plan-list/components/lesson-plan-version-select/lesson-plan-version-select.vue";
import UnitSelect from "../../../lesson-plan-list/components/unit-select/unit-select.vue";
import { ILessonPlanVersionModel } from "@/models/lesson-plan";
import { VCSLevelModel } from "@/models/title-list-model";
import { fmtMsg, GLUtil } from "commonui";
import { Paths } from "@/util/paths";

@Component({
	components: {
		Modal,
		Select,
		Button,
		SelectOption: Select.Option,
		LessonPlanVersionSelect,
		UnitSelect
	}
})
export default class SwitchModal extends Vue {
	@Prop() visible: boolean = false;
	@Prop() toggleVisible!: () => void;
	private lessonPlanListModule = getModule(LessonPlanListState);
	created() {
		const { versionGroupId, methodology, lessonPlanVersionId, unitId } = this.$route.params;
		this.lessonPlanListModule.fetchLessonPlans({
			versionGroupId,
			methodology,
			lessonPlanVersionId,
			unitId: unitId ? parseInt(unitId as string, 10) : undefined
		});
	}

	get componentTaughtType(): any {
		return ComponentTaughtType;
	}

	get lessonPlanLocale(): any {
		return LessonPlanLocale;
	}

	get titleText() {
		return fmtMsg(LessonPlanLocale.SwitchModalTitle);
	}

	get applyText() {
		return fmtMsg(CommonLocale.CommonApplyButtonText);
	}

	get cancelText() {
		return fmtMsg(CommonLocale.CommonCancelButtonText);
	}

	get isREP(): boolean {
		return this.lessonPlanListModule.currentMethodology === MethodologyTypeEnum.REP;
	}

	get lessonPlanVersions(): ILessonPlanVersionModel[] {
		return this.lessonPlanListModule.currentLessonPlanVersions;
	}

	get activeLessonPlanVersion(): ILessonPlanVersionModel {
		return this.lessonPlanListModule.currentLessonPlanVersion;
	}

	get units(): VCSLevelModel[] {
		return this.lessonPlanListModule.currentUnits;
	}

	get activeUnit(): VCSLevelModel {
		return this.lessonPlanListModule.currentUnit;
	}

	get disabledApplyBtn(): boolean {
		return (
			this.activeUnit.id === parseInt(this.$route.params.unitId) &&
			this.activeLessonPlanVersion?.id === this.$route.params.lessonPlanVersionId
		);
	}

	handleCancel() {
		this.lessonPlanListModule.resetLessonAndUnitToOrigin();
		this.toggleVisible();
	}

	handleApply() {
		this.toggleVisible();
		this.$router
			.push({
				path: GLUtil.pathStringify(Paths.MasterPlan, {
					versionGroupId: this.lessonPlanListModule.currentLessonPlanVersion.versionGroupId,
					methodology: this.lessonPlanListModule.currentMethodology,
					lessonPlanVersionId: this.activeLessonPlanVersion.id,
					unitId: this.activeUnit.id
				})
			})
			.then(() => window.location.reload())
			.catch((e) => {
				console.error(e);
			});
	}

	onLessonPlanVersionChanged(value: ILessonPlanVersionModel): void {
		this.lessonPlanListModule.setCurrentLessonPlanVersion(value);
	}

	onUnitChanged(value: VCSLevelModel): void {
		this.lessonPlanListModule.setCurrentUnit(value);
	}
}
